import axios from "axios";
import { get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
const GOOGLE_MAP_API_KEY = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
 
export default {
  name: "IncidentLogger",
  components: {
    HomeNavBar,
  },
  data() {
    return ({
      base_url: process.env.VUE_APP_BACKEND_API_URL,
      entity_types: [],
      selected_type_id: null,
      selected_form_id: null,
      form_schema: [],
      form_data: {},
      is_loading: false,
      is_submitting: false,
      feedback: { message: "", color: "" },
      logged_entries: [],
      search_query: "",
      filter_status: "All",
      filter_location: "All",
      filter_type: "All",
      statuses: [],
      selected: null,
      success_screen: false,
      reference_number: "",
      loading: false,
      show_map_view: typeof window === "undefined" ? true : window.innerWidth >= 992,
      incident_map: null,
      incident_markers: [],
      incident_map_marker: null,
      filter_map: null,
      filter_map_marker: null,
      map_geocoder: null,
      filter_dropdown_open: false,
      google_maps_load_promise: null,
      location_geocode_cache: {},
      filter_map_default_center: { lat: 6.5244, lng: 3.3792 },
      project_id : process.env.VUE_APP_PROJECT_ID,
      user_details: get_user_details() || {},
      active_profile: null,
      activity_open: {},
      liked_incidents: JSON.parse(localStorage.getItem("likedIncidents") || "{}"),
      comment_panel_open: {},
      share_menu_open: {},
      comment_drafts: {},
      editing_comment_id: null,
      editing_comment_drafts: {},
      comment_action_loading: {},
      isDragging: false
    });
  },
  watch: {
    selected_type_id(newVal) {
      if (newVal) {
        this.fetch_form_by_entity_type();
      } else {
        this.form_schema = [];
        this.form_data = {};
      }
    },
    show_map_view(newValue) {
      if (!newValue && this.incident_map) {
        this.incident_markers.forEach(marker => marker.setMap(null));
        this.incident_markers = [];
        this.incident_map = null;
      }
    },
    filter_status() {
      this.reload_map();
    },
    filter_location() {
      this.reload_map();
    },
    filter_type() {
      this.reload_map();
    },
    search_query() {
      this.reload_map();
    },
    logged_entries: {
      handler() {
        this.reload_map();
      },
      deep: true
    }
  },
  computed: {
    profileImage() {
      const files =
        this.active_profile?.profile_files ||
        this.active_profile?.user?.profile?.profile_files ||
        this.active_profile?.company?.base_profile?.profile_files ||
        [];

      const profilePicture = files.find(file => file.profile_file_type === "profile_picture") || files[0];

      return profilePicture?.file?.file_url || profilePicture?.file?.url || null;
    },
    composer_display_name() {
      return (
        this.active_profile?.profile_name ||
        this.active_profile?.company?.company_name ||
        this.active_profile?.user?.first_name ||
        this.user_details?.first_name ||
        "there"
      );
    },
    active_filter_count() {
      let count = 0;

      if (this.search_query) count++;
      if (this.filter_status !== 'All') count++;
      if (this.filter_type !== 'All') count++;
      if (this.filter_location !== 'All') count++;

      return count;
    },
    workflow_steps() {
      const sequenceNames = ['Pending Application', 'Assigned', 'In Progress', 'Resolved'];

      if (!this.statuses.length) {
        return sequenceNames.map(name => ({ status: name }));
      }

      return sequenceNames.map(name => {
        const found = this.statuses.find(s => s.status === name);
        return found || { status: name };
      });
    },

    workflow_display_steps() {
      return [
        { key: 'pending_review', label: 'Pending Review', icon: 'bi bi-hourglass-split', match: ['Pending Application', 'Pending Review', 'Pending'] },
        { key: 'assigned', label: 'Assigned', icon: 'bi bi-person-fill', match: ['Assigned'] },
        { key: 'in_progress', label: 'In Progress', icon: 'bi bi-wrench-adjustable-circle', match: ['In Progress'] },
        { key: 'approved', label: 'Approved', icon: 'bi bi-check2', match: ['Approved'] },
        { key: 'resolved', label: 'Resolved', icon: 'bi bi-stars', match: ['Resolved'] }
      ];
    },
    unique_locations() {
      const locations = this.logged_entries
        .map(r => r.location)
        .filter(l => l && l.trim() !== "");
      return ['All', ...new Set(locations)];
    },
    filtered_entries() {
      return this.logged_entries.filter(r => {
        const matchesStatus = this.filter_status === 'All' || r.status?.status === this.filter_status;
        const matchesLocation = this.filter_location === 'All' || r.location === this.filter_location;
        const matchesType = this.filter_type === 'All' || r.entity_type?.entity_type_name === this.filter_type;

        const searchLower = this.search_query.toLowerCase();
        const matchesSearch = !this.search_query ||
          `INC-${r.id}`.toLowerCase().includes(searchLower) ||
          r.description?.toLowerCase().includes(searchLower) ||
          r.location?.toLowerCase().includes(searchLower) ||
          r.entity_type?.entity_type_name?.toLowerCase().includes(searchLower);

        return matchesStatus && matchesLocation && matchesType && matchesSearch;
      });
    },
    incident_category_counts() {
      const counts = new Map();

      this.category_count_entries.forEach(entry => {
        const name = this.get_incident_category_name(entry);
        const current = counts.get(name) || {
          name,
          count: 0,
          color: this.get_incident_category_color(name),
        };

        current.count += 1;
        counts.set(name, current);
      });

      return Array.from(counts.values()).sort((a, b) => a.name.localeCompare(b.name));
    },
    category_count_entries() {
      return this.logged_entries.filter(r => {
        const matchesStatus = this.filter_status === 'All' || r.status?.status === this.filter_status;
        const matchesLocation = this.filter_location === 'All' || r.location === this.filter_location;

        const searchLower = this.search_query.toLowerCase();
        const matchesSearch = !this.search_query ||
          `INC-${r.id}`.toLowerCase().includes(searchLower) ||
          r.description?.toLowerCase().includes(searchLower) ||
          r.location?.toLowerCase().includes(searchLower) ||
          r.entity_type?.entity_type_name?.toLowerCase().includes(searchLower);

        return matchesStatus && matchesLocation && matchesSearch;
      });
    }
  },
 
  mounted() {
    this.load_active_profile();
    this.fetch_entity_types();
    this.view_form_statuses();
    this.fetch_pending_entities();
    this.incident_modal_element = document.getElementById("incidentModal");
    this.incident_modal_element?.addEventListener("shown.bs.modal", this.handle_incident_modal_shown);
    this.incident_modal_element?.addEventListener("hidden.bs.modal", this.handle_incident_modal_hidden);
    if (this.show_map_view) {
      this.load_google_maps_api()
        .then(() => this.$nextTick(() => this.init_incident_map()))
        .catch(err => {
          console.error("Unable to load Google Maps", err);
        });
    }
  },
  beforeUnmount() {
    this.incident_modal_element?.removeEventListener("shown.bs.modal", this.handle_incident_modal_shown);
    this.incident_modal_element?.removeEventListener("hidden.bs.modal", this.handle_incident_modal_hidden);
  },
  methods: {
    parse_stored_profile(key) {

      return JSON.parse(localStorage.getItem(key) || "null");
    },
    load_active_profile() {
      const storageKeys = ["activeProfile", "active_profile", "base_profile", "activeBaseProfile"];

      for (const key of storageKeys) {
        const storedProfile = this.parse_stored_profile(key);

        if (storedProfile) {
          this.active_profile = storedProfile;
          return;
        }
      }
    },
    toggle_activity(id) {
      const activityOpen = this.activity_open || {};
      const current = !!Reflect.get(activityOpen, id);
      const nextActivityOpen = { ...activityOpen };
      Reflect.set(nextActivityOpen, id, !current);
      this.activity_open = nextActivityOpen;
    },
    is_activity_open(id) {
      return !!Reflect.get(this.activity_open || {}, id);
    },
    toggle_comment_panel(id) {
      this.comment_panel_open = {
        ...(this.comment_panel_open || {}),
        [id]: !this.is_comment_panel_open(id)
      };
    },
    is_comment_panel_open(id) {
      return !!Reflect.get(this.comment_panel_open || {}, id);
    },
    toggle_share_menu(id) {
      this.share_menu_open = {
        ...(this.share_menu_open || {}),
        [id]: !this.is_share_menu_open(id)
      };
    },
    is_share_menu_open(id) {
      return !!Reflect.get(this.share_menu_open || {}, id);
    },
    close_share_menu(id) {
      this.share_menu_open = {
        ...(this.share_menu_open || {}),
        [id]: false
      };
    },
    get_reporter_name(r) {
      const user = r.user || r.created_by || r.reporter || r.applicant || r.submitted_by;
      if (!user) return 'Citizen';

      if (typeof user === 'string') return user;

      const fullName = [
        user.first_name,
        user.last_name
      ].filter(Boolean).join(' ').trim();

      return fullName || user.name || user.username || 'Citizen';
    },
    get_reporter_initials(r) {
      const name = this.get_reporter_name(r);
      const initials = name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part.charAt(0).toUpperCase())
        .join('');

      return initials || 'C';
    },
    get_attachment_count(r) {
      if (Array.isArray(r.files)) return r.files.length;
      if (Array.isArray(r.report_files)) return r.report_files.length;
      return 0;
    },
    is_incident_liked(id) {
      return !!Reflect.get(this.liked_incidents || {}, id);
    },
    get_incident_like_count(r) {
      return Number(r.total_likes ?? r.like_count ?? r.likes_count ?? r.likes?.length ?? 0) || 0;
    },
    async toggle_incident_like(r) {
      console.log("r",r)
      const wasLiked = this.is_incident_liked(r.id);

      this.liked_incidents = {
        ...(this.liked_incidents || {}),
        [r.id]: !wasLiked
      };
      localStorage.setItem("likedIncidents", JSON.stringify(this.liked_incidents));

      r.total_likes = Math.max(this.get_incident_like_count(r) + (wasLiked ? -1 : 1), 0);

      try {
        const { data } = await axios.post(
          `${this.base_url}/report_incident_management/like_incident_report/`,
          this.get_incident_reference_payload(r),
          this.axios_config()
        );

        this.apply_incident_interaction_summary(r, data);
      } catch (err) {
        this.liked_incidents = {
          ...(this.liked_incidents || {}),
          [r.id]: wasLiked
        };
        localStorage.setItem("likedIncidents", JSON.stringify(this.liked_incidents));
        r.total_likes = Math.max(this.get_incident_like_count(r) + (wasLiked ? 1 : -1), 0);
        console.error("Failed to like incident report", err);
      }
    },
    get_incident_comments(r) {
      const backendComments = Array.isArray(r.comments) ? r.comments : [];
      return backendComments;
    },
    get_incident_comment_count(r) {
      return Number(r.total_comments ?? r.comment_count ?? r.comments_count ?? r.comments?.length ?? 0) || 0;
    },
    get_comment_author(comment) {
      const user = comment.user || comment.created_by || comment.author;
      if (!user) return 'You';
      if (typeof user === 'string') return user;

      const name = [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
      return name || user.name || user.username || 'Citizen';
    },
    get_comment_initials(comment) {
      const name = this.get_comment_author(comment);
      return name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part.charAt(0).toUpperCase())
        .join('') || 'C';
    },
    get_comment_text(comment) {
      return comment.comment_text || comment.comment || comment.text || '';
    },
    get_current_user_id() {
      return get_user_details()?.user_id || localStorage.getItem('user_id') || '';
    },
    can_manage_comment(comment) {
      const currentUserId = String(this.get_current_user_id() || '');
      const commentUserId = String(comment?.user?.id || comment?.created_by?.id || comment?.author?.id || '');
      return !!currentUserId && !!commentUserId && currentUserId === commentUserId;
    },
    is_comment_editing(comment) {
      return this.editing_comment_id === comment.id;
    },
    start_edit_incident_comment(comment) {
      this.editing_comment_id = comment.id;
      this.editing_comment_drafts = {
        ...(this.editing_comment_drafts || {}),
        [comment.id]: this.get_comment_text(comment)
      };
    },
    cancel_edit_incident_comment() {
      this.editing_comment_id = null;
    },
    is_comment_action_loading(commentId) {
      return !!Reflect.get(this.comment_action_loading || {}, commentId);
    },
    set_comment_action_loading(commentId, isLoading) {
      this.comment_action_loading = {
        ...(this.comment_action_loading || {}),
        [commentId]: isLoading
      };
    },
    replace_incident_comment(r, updatedComment) {
      const comments = this.get_incident_comments(r);
      r.comments = comments.map(comment => (
        comment.id === updatedComment.id ? updatedComment : comment
      ));
    },
    remove_incident_comment(r, commentId) {
      r.comments = this.get_incident_comments(r).filter(comment => comment.id !== commentId);
      r.total_comments = r.comments.length;
      r.comment_count = r.total_comments;
    },
    async submit_edit_incident_comment(r, comment) {
      const draft = (Reflect.get(this.editing_comment_drafts || {}, comment.id) || '').trim();
      if (!draft) return;

      this.set_comment_action_loading(comment.id, true);

      try {
        const { data } = await axios.patch(
          `${this.base_url}/report_incident_management/edit_incident_report_comment/`,
          {
            comment_id: comment.id,
            comment: draft
          },
          this.axios_config()
        );

        if (data?.comment) {
          this.replace_incident_comment(r, data.comment);
        }

        if (data?.summary) {
          this.apply_incident_interaction_summary(r, data.summary);
        }

        this.editing_comment_id = null;
      } catch (err) {
        console.error("Failed to edit incident comment", err);
      } finally {
        this.set_comment_action_loading(comment.id, false);
      }
    },
    async delete_incident_comment(r, comment) {
      if (!comment?.id || !window.confirm("Delete this comment?")) return;

      this.set_comment_action_loading(comment.id, true);

      try {
        const { data } = await axios.delete(
          `${this.base_url}/report_incident_management/delete_incident_report_comment/`,
          {
            ...this.axios_config(),
            data: {
              comment_id: comment.id
            }
          }
        );

        this.remove_incident_comment(r, comment.id);
        this.apply_incident_interaction_summary(r, data);
      } catch (err) {
        console.error("Failed to delete incident comment", err);
      } finally {
        this.set_comment_action_loading(comment.id, false);
      }
    },
    async submit_incident_comment(r) {
      const draft = (Reflect.get(this.comment_drafts || {}, r.id) || '').trim();
      if (!draft) return;

      this.comment_drafts = {
        ...(this.comment_drafts || {}),
        [r.id]: ''
      };

      try {
        const { data } = await axios.post(
          `${this.base_url}/report_incident_management/comment_incident_report/`,
          {
            ...this.get_incident_reference_payload(r),
            comment: draft
          },
          this.axios_config()
        );

        if (data?.summary) {
          this.apply_incident_interaction_summary(r, data.summary);
        }

        if (data?.comment && !this.get_incident_comments(r).some(comment => comment.id === data.comment.id)) {
          r.comments = [data.comment, ...this.get_incident_comments(r)];
          r.total_comments = this.get_incident_comment_count(r) || r.comments.length;
        }
      } catch (err) {
        this.comment_drafts = {
          ...(this.comment_drafts || {}),
          [r.id]: draft
        };
        console.error("Failed to comment on incident report", err);
      }
    },
    get_incident_reference_payload(r) {
      const payload = {};

      console.log("payload",payload);
      const incidentReferenceId = r.incident_reference_id || r.id;

      if (incidentReferenceId) payload.incident_reference_id = incidentReferenceId;

      return payload;
    },
    apply_incident_interaction_summary(r, responseData) {
      const summary = responseData?.summary || responseData || {};

      const likeCount = summary.total_likes ?? summary.like_count ?? summary.likes_count ?? summary.likes?.length;
      const commentCount = summary.total_comments ?? summary.comment_count ?? summary.comments_count ?? summary.comments?.length;
      const likedByUser = summary.liked_by_user ?? summary.user_has_liked ?? summary.has_liked ?? summary.is_liked;
      const comments = summary.comments || summary.recent_comments || summary.comment_data;

      if (likeCount !== undefined) {
        r.total_likes = Number(likeCount) || 0;
        r.like_count = r.total_likes;
      }

      if (commentCount !== undefined) {
        r.total_comments = Number(commentCount) || 0;
        r.comment_count = r.total_comments;
      }

      if (Array.isArray(comments)) {
        r.comments = comments;
      }

      if (likedByUser !== undefined) {
        this.liked_incidents = {
          ...(this.liked_incidents || {}),
          [r.id]: !!likedByUser
        };
        localStorage.setItem("likedIncidents", JSON.stringify(this.liked_incidents));
      }
    },
    async fetch_incident_interactions(r) {
      return axios.get(
        `${this.base_url}/report_incident_management/get_incident_report_interactions/`,
        {
          ...this.axios_config(),
          params: this.get_incident_reference_payload(r)
        }
      )
        .then(({ data }) => this.apply_incident_interaction_summary(r, data))
        .catch(err => console.warn("Failed to fetch incident interactions", r.id, err));
    },
    get_incident_url(r) {
      const base = `${window.location.origin}${this.$route?.path || window.location.pathname}`;
      return `${base}?incident_id=${encodeURIComponent(r.id)}`;
    },
    async copy_incident_link(r) {
      const link = this.get_incident_url(r);

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(link);
        } else {
          const textArea = document.createElement('textarea');
          textArea.value = link;
          textArea.setAttribute('readonly', '');
          textArea.className = 'clipboard-copy-buffer';
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
        }
      } catch (err) {
        console.warn('Unable to copy incident link', err);
      } finally {
        this.close_share_menu(r.id);
      }
    },
    clear_all_filters() {
      this.search_query = '';
      this.filter_status = 'All';
      this.filter_type = 'All';
      this.filter_location = 'All';
    },
    handle_incident_modal_shown() {
      this.select_default_entity_type(true);
    },
    handle_incident_modal_hidden() {
      this.clear_incident_modal();
    },
    clear_incident_modal() {
      this.success_screen = false;
      this.reference_number = "";
      this.selected_type_id = null;
      this.selected_form_id = null;
      this.form_schema = [];
      this.form_data = {};
      this.files = [];
      this.feedback = { message: "", color: "" };
      this.is_submitting = false;
      this.is_loading = false;
    },
    select_map_category(categoryName) {
      this.filter_type = this.filter_type === categoryName ? 'All' : categoryName;
    },
    reload_map() {
      if (this.show_map_view) {
        this.load_incident_markers_on_map();
      }
    },
    toggle_map() {
      this.show_map_view = !this.show_map_view;

      if (this.show_map_view) {
        this.load_google_maps_api()
          .then(() => {
            this.$nextTick(() => {
              if (this.show_map_view && !this.incident_map) {
                this.init_incident_map();
              }
            });
          })
          .catch(err => {
            console.error("Unable to load Google Maps", err);
          });
      }
    },
    init_incident_map() {
      const mapElement = document.getElementById("incident-map");

      if (!mapElement) return;

      this.incident_map = new window.google.maps.Map(mapElement, {
        center: { lat: -26.2041, lng: 28.0473 }, // Johannesburg
        zoom: 10,
        disableDefaultUI: true,
        gestureHandling: "cooperative",
        scrollwheel: false,
      });

      this.load_incident_markers_on_map();
    },
    async load_incident_markers_on_map() {
      if (!this.incident_map) return;

      // clear old markers
      this.incident_markers.forEach(m => m.setMap(null));
      this.incident_markers = [];

      const bounds = new window.google.maps.LatLngBounds();

      const addMarker = (positionLiteral, entry) => {
        const categoryName = this.get_incident_category_name(entry);
        const categoryColor = this.get_incident_category_color(categoryName);
        const marker = new window.google.maps.Marker({
          map: this.incident_map,
          position: positionLiteral,
          title: `INC-${entry.id}`,
          icon: this.get_incident_marker_icon(categoryColor),
        });

        const infoWindow = new window.google.maps.InfoWindow({
          content: `
            <div class="incident-map-info-window">
              <b>INC-${entry.id}</b><br/>
              <small>${categoryName}</small><br/>
              ${entry.description || ""}<br/>
              <small>Status: ${entry.status?.status || ""}</small>
            </div>
          `,
        });

        marker.addListener("click", () => {
          infoWindow.open(this.incident_map, marker);
          this.select_report(entry);
        });

        this.incident_markers.push(marker);
        bounds.extend(positionLiteral);
        this.incident_map.fitBounds(bounds, 80);
      };

      const processEntry = async entry => {
        if (!entry.location) return;

        try {
          const cachedLocation = this.location_geocode_cache[entry.location];

          let position = cachedLocation;

          if (!position) {
            const coords = await this.get_location_coordinates(entry.location);
            position = this.normalize_lat_lng(coords);
            this.location_geocode_cache[entry.location] = position;
          }

          if (position) {
            addMarker(position, entry);
          }

        } catch (err) {
          console.warn("Failed to map address", entry.location, err);
        }
      };

      await Promise.all(this.filtered_entries.map(processEntry));
    },
    get_incident_category_name(entry) {
      return entry?.entity_type?.entity_type_name || "Uncategorized";
    },
    get_incident_category_color(categoryName) {
      const palette = [
        "#0d6efd",
        "#dc3545",
        "#198754",
        "#fd7e14",
        "#6f42c1",
        "#20c997",
        "#d63384",
        "#0dcaf0",
        "#ffc107",
        "#6c757d",
      ];
      const normalizedName = String(categoryName || "Uncategorized");
      const entityTypeIndex = this.entity_types.findIndex(type => type.entity_type_name === normalizedName);

      if (entityTypeIndex !== -1) {
        return palette[entityTypeIndex % palette.length];
      }

      const hash = normalizedName.split("").reduce((total, char) => total + char.charCodeAt(0), 0);

      return palette[hash % palette.length];
    },
    get_incident_marker_icon(color) {
      const markerColor = /^#[0-9a-f]{6}$/i.test(color) ? color : "#0d6efd";
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="44" viewBox="0 0 36 44">
          <path fill="${markerColor}" d="M18 0C8.1 0 0 8.1 0 18c0 13.5 18 26 18 26s18-12.5 18-26C36 8.1 27.9 0 18 0z"/>
          <circle cx="18" cy="18" r="7" fill="#ffffff"/>
        </svg>
      `.trim();

      return ({
        url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
        scaledSize: new window.google.maps.Size(30, 36),
        anchor: new window.google.maps.Point(15, 36),
      });
    },
    get_step_index(r) {
      const currentStatusName = r.status?.status || 'Pending Application';
      const sequenceNames = ['Pending Application', 'Assigned', 'In Progress', 'Resolved'];
      const index = sequenceNames.indexOf(currentStatusName);
      return index !== -1 ? index : 0;
    },

    get_display_step_index(r) {
      const currentStatusName = r.status?.status || 'Pending Application';
      const steps = this.workflow_display_steps;

      const foundIndex = steps.findIndex(s => (s.match || []).includes(currentStatusName));
      if (foundIndex !== -1) return foundIndex;

      if (currentStatusName === 'Resolved') return steps.length - 1;
      if (currentStatusName === 'In Progress') return 2;
      if (currentStatusName === 'Assigned') return 1;
      return 0;
    },

    get_step_class(r, index) {
      const currentIndex = this.get_display_step_index(r);
      if (index < currentIndex) return 'is-done';
      if (index === currentIndex) return 'is-current';
      return 'is-upcoming';
    },

    get_current_status_label(r) {
      const currentIndex = this.get_display_step_index(r);
      const step = Reflect.get(this.workflow_display_steps, currentIndex);
      if (step?.label) return step.label;
      const raw = r.status?.status;
      if (raw === 'Pending Application') return 'Pending Review';
      return raw || 'Pending Review';
    },

    get_current_dot_class(r) {
      const currentIndex = this.get_display_step_index(r);
      if (currentIndex === 0) return 'incident-dot-warning';
      if (currentIndex === 1) return 'incident-dot-muted';
      if (currentIndex === 2) return 'incident-dot-info';
      return 'incident-dot-success';
    },

    get_assigned_name(r) {
      const a = Array.isArray(r.assigned_administrators) ? r.assigned_administrators[0] : null;
      if (!a) return 'Unassigned';
      const name = `${a.first_name || ''} ${a.last_name || ''}`.trim();
      return name || 'Unassigned';
    },

    get_priority_label(r) {
      const candidate =
        r.priority?.name ||
        r.priority ||
        r.severity?.name ||
        r.severity ||
        r.urgency?.name ||
        r.urgency ||
        r.level ||
        r.priority_level;

      if (!candidate) return '';
      if (typeof candidate === 'string') return candidate;

      if (typeof candidate === 'number') {
        if (candidate >= 3) return 'High';
        if (candidate === 2) return 'Medium';
        return 'Low';
      }

      return '';
    },

    get_remaining_label(r) {
      return (
        r.time_remaining ||
        r.remaining_time ||
        r.remaining_label ||
        r.sla_remaining ||
        ''
      );
    },

    get_report_title(r) {
      const explicit = (r.title || r.subject || r.summary || '').toString().trim();
      if (explicit) return explicit;

      const desc = (r.description || '').toString();
      if (desc.includes('\n')) {
        const firstLine = desc.split('\n').map(s => s.trim()).find(Boolean);
        if (firstLine) return firstLine.length > 80 ? `${firstLine.slice(0, 80)}…` : firstLine;
      }

      return r.entity_type?.entity_type_name || `INC-${r.id}`;
    },

    get_report_body(r) {
      const desc = (r.description || '').toString().trim();
      if (!desc) return '';

      if (desc.includes('\n')) {
        const parts = desc.split('\n');
        const firstLine = (parts.shift() || '').trim();
        const rest = parts.join('\n').trim();
        if (firstLine && rest && firstLine.length <= 80) return rest;
      }

      return desc;
    },

    format_created_at(value) {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);

      const weekday = new Intl.DateTimeFormat('en-GB', { weekday: 'short' }).format(date);
      const day = new Intl.DateTimeFormat('en-GB', { day: '2-digit' }).format(date);
      const month = new Intl.DateTimeFormat('en-GB', { month: 'long' }).format(date);
      const year = new Intl.DateTimeFormat('en-GB', { year: 'numeric' }).format(date);
      const time = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false }).format(date);

      return `${weekday} ${day} ${month} ${year} · ${time}`;
    },

    format_time(value) {
      if (!value) return '';
      const asString = String(value);
      const match = asString.match(/(\d{2}:\d{2})/);
      if (match) return match[1];

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false }).format(date);
    },

    get_channel_badges(r) {
      const badges = [];
      const emailTime = r.email_time || r.last_email_time || r.email_sent_at;
      const inAppTime = r.in_app_time || r.last_in_app_time || r.in_app_sent_at || r.notification_sent_at;

      if (emailTime) {
        badges.push({
          key: 'email',
          label: `Email · ${this.format_time(emailTime)}`,
          icon: 'bi bi-envelope-fill',
          variant: 'incident-channel-email'
        });
      }

      if (inAppTime) {
        badges.push({
          key: 'in_app',
          label: `In-App · ${this.format_time(inAppTime)}`,
          icon: 'bi bi-bell-fill',
          variant: 'incident-channel-inapp'
        });
      }

      return badges;
    },
 
    initialize_map(questionId) {
      this.$nextTick(() => {
        const inputElement = document.getElementById(`search-input-${questionId}`);
        const mapElement = document.getElementById(`map-${questionId}`);
 
        if (!inputElement || !mapElement) {
          console.warn("Location elements not found in DOM yet.");
          return;
        }
 
        // 1. Initialize ONLY the autocomplete search on the input field
        const autocomplete = new window.google.maps.places.Autocomplete(inputElement);
 
        // 2. Listen for when the user actually selects an address
        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
 
          // If they pressed enter without selecting a valid place, ignore it
          if (!place.geometry) return;
 
          // 3. UNHIDE the map container now that we need it
          mapElement.classList.remove('d-none');
 
          // 4. NOW build the map (since the div is visible, Google Maps won't crash)
          const map = new window.google.maps.Map(mapElement, {
            center: place.geometry.location,
            zoom: 16,
          });
 
          // 5. Drop the pin
          new window.google.maps.Marker({
            position: place.geometry.location,
            map: map,
            title: place.name
          });
 
          // 6. Update your Vue form_data so it submits to the backend
          Reflect.set(this.form_data, questionId, inputElement.value);
        });
      });
    },

    load_google_maps_api() {
      if (window.google && window.google.maps) {
        return Promise.resolve();
      }

      if (this.google_maps_load_promise) {
        return this.google_maps_load_promise;
      }

      this.google_maps_load_promise = new Promise((resolve, reject) => {
        const scriptId = "googleMapsScript";
        let script = document.getElementById(scriptId);

        if (!script) {
          script = document.createElement("script");
          script.id = scriptId;
          script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places&v=weekly`;
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);
        }

        const onLoad = () => {
          cleanup();
          resolve();
        };

        const onError = (error) => {
          cleanup();
          reject(error || new Error("Google Maps script failed to load"));
        };

        const cleanup = () => {
          script.removeEventListener("load", onLoad);
          script.removeEventListener("error", onError);
        };

        script.addEventListener("load", onLoad);
        script.addEventListener("error", onError);

        if (window.google && window.google.maps) {
          cleanup();
          resolve();
        }
      });

      return this.google_maps_load_promise;
    },

    load_google_map_event(questionId) {
      this.load_google_maps_api()
        .then(() => this.initialize_map(questionId))
        .catch(err => {
          console.error("Unable to load Google Maps for the location field", err);
        });
    },
    normalize_lat_lng(position) {
      if (!position) return null;

      // Supports both google.maps.LatLng and LatLngLiteral shapes
      if (typeof position.lat === 'function' && typeof position.lng === 'function') {
        return ({ lat: position.lat(), lng: position.lng() });
      }

      if (typeof position.lat === 'number' && typeof position.lng === 'number') {
        return ({ lat: position.lat, lng: position.lng });
      }

      const lat = Number(position.lat);
      const lng = Number(position.lng);
      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        return ({ lat, lng });
      }

      return null;
    },
    geocode_address(address) {
      return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address }, (results, status) => {
          if (status === "OK" && results[0]) {
            resolve(results[0].geometry.location);
          } else {
            const error = new Error(`Geocode failed: ${status}`);
            error.status = status;
            reject(error);
          }
        });
      });
    },

    find_place_location(address) {
      return new Promise((resolve, reject) => {
        const service = new window.google.maps.places.PlacesService(this.incident_map);
        service.findPlaceFromQuery(
          { query: address, fields: ["geometry"] },
          (results, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && results[0]?.geometry?.location) {
              resolve(results[0].geometry.location);
            } else {
              const error = new Error(`Places search failed: ${status}`);
              error.status = status;
              reject(error);
            }
          }
        );
      });
    },

    get_location_coordinates(address) {
      return this.geocode_address(address).catch(err => {
        // Fallback to Places search when Geocoder fails (rate limits / partial addresses)
        if (this.incident_map && window.google?.maps?.places) {
          return this.find_place_location(address);
        }
        throw err;
      });
    },
    axios_config: () => ({
      headers: {
        "Authorization": `Token ${get_token()}`
      }
    }),
 
    select_report(r) {
      this.selected = r
      this.detailTab = 'timeline'
    },
 
    status_count(s) {
      const count = s === 'All'
        ? this.logged_entries.length
        : this.logged_entries.filter(r => r.status.status === s).length
      return count > 0 ? count : ''
    },
    async view_form_statuses() {
      const res = await axios.get(
        `${this.base_url}/report_incident_management/view_form_statuses/`,
        { ...this.axios_config() }
      );
 
      this.statuses = res.data.data || [];
    },
 
    handle_file_upload(event, questionId) {
      this.isDragging = false;

      // Convert FileList to Array and attach a preview URL if it's an image
      const incomingFiles = event.dataTransfer?.files || event.target?.files || [];
      const files = Array.from(incomingFiles).map(file => {
        if (file.type.startsWith('image/')) {
          // Create a temporary URL for the browser to display the image
          file.previewUrl = URL.createObjectURL(file);
        }
        return file;
      });
 
      let currentFiles = Reflect.get(this.form_data, questionId);
 
      if (!Array.isArray(currentFiles)) {
        currentFiles = [];
        Reflect.set(this.form_data, questionId, currentFiles);
      }
 
      currentFiles.push(...files);
    },
 
    set_error(message) {
      this.feedback = { message };
    },
 
    async fetch_entity_types() {
      const config = this.axios_config();
      config.params = { project_id: this.project_id };
      const res = await axios.get(
        `${this.base_url}/report_incident_management/pull_entity_types/`, config
      );
 
      this.entity_types = this.sort_entity_types(res.data.data || []);
      this.select_default_entity_type();
    },
    sort_entity_types(types) {
      return [...types].sort((a, b) => {
        const aName = String(a.entity_type_name || "").trim().toLowerCase();
        const bName = String(b.entity_type_name || "").trim().toLowerCase();

        if (aName === "other") return -1;
        if (bName === "other") return 1;

        return aName.localeCompare(bName);
      });
    },
    select_default_entity_type(forceReload = false) {
      if (typeof window !== "undefined" && window.innerWidth < 768) return;

      const defaultType = this.entity_types[0];

      if (!defaultType) return;

      if (forceReload && this.selected_type_id === defaultType.id) {
        this.fetch_form_by_entity_type();
        return;
      }

      this.selected_type_id = defaultType.id;
    },
 
    // Step 1: Fetch Form ID by Entity Type
    async fetch_form_by_entity_type() {
      this.is_loading = true;
      this.form_schema = [];
      this.form_data = {};
      this.feedback = { message: "", color: "" };
 
      const config = this.axios_config();
      config.params = { entity_type_id: this.selected_type_id }
      const res = await axios.get(
        `${this.base_url}/report_incident_management/pull_entity_form/`, config
      );
 
      // Parse stringified JSON if backend returns it
      const parsed = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
      const formId = parsed.data[0]?.id;
 
      if (!formId) {
        this.set_error("Form not found for selected type.");
        return;
      }
 
      this.selected_form_id = formId;
      await this.fetch_empty_form(formId);
    },
 
    // Step 2: Fetch Empty Form (Sections + Questions)
    async fetch_empty_form(formId) {
 
      const config = this.axios_config();
      config.params = { form_id: formId };
      try {
        const res = await axios.get(
          `${this.base_url}/report_incident_management/get_empty_form_by_id/`,
          config
        );
 
        const data = res.data.data;
        this.form_schema = data.sections || [];
 
        // Initialize reactive form_data
        this.form_schema.forEach(section => {
          section.questions.forEach(q => {
            Reflect.set(this.form_data, q.section_question_id, "");
 
            if (q.question_type.question_type === 'short_text' && q.question_text.toLowerCase().includes('location')) {
              this.load_google_map_event(q.section_question_id);
            }
          });
        });
 
      } catch (err) {
        console.error(err);
        this.set_error("Failed to load form questions.");
      }
    },
 
    remove_file(questionId, index) {
      // 1. Safely check if the property exists
      if (Reflect.has(this.form_data, questionId)) {
        const arr = Reflect.get(this.form_data, questionId);
 
        if (Array.isArray(arr)) {
          // 2. Get the specific file object to clean up memory
          const fileToRemove = Reflect.get(arr, index);
 
          if (fileToRemove) {
            // Revoke the Blob URL to prevent memory leaks
            if (fileToRemove.previewUrl) {
              URL.revokeObjectURL(fileToRemove.previewUrl);
            }
 
            // 3. Remove the file using Reflect.apply to ensure Proxy compatibility
            const spliceFn = Reflect.get(arr, 'splice');
            Reflect.apply(spliceFn, arr, [index, 1]);
          }
        }
      }
    },
 
    // Step 3: Submit Answers in Xverdict format
    async submit_incident() {
      this.is_submitting = true;
      this.feedback = { message: "", color: "" };
 
      try {
 
 
 
        const form_data = new FormData()
        const answers = []
 
        form_data.append("entity_type_id", this.selected_type_id);
        form_data.append("project_id", this.project_id);
        form_data.append("form_ids", this.selected_form_id);
        form_data.append("current_section_index", 0);
 
        this.form_schema.forEach(section => {
          section.questions.forEach(q => {
            const value = this.form_data[q.section_question_id];
            const isFile = q.question_type.question_type === "file";
 
            if (isFile && Array.isArray(value) && value.length > 0) {
              value.forEach(file => {
                if (file instanceof File) {
                  form_data.append(`file_${q.section_question_id}`, file);
                }
              });
 
              // Save names in answers
              answers.push({
                section_question_id: q.section_question_id,
                answer_text: value.map(f => f.name).join(", ") // multiple file names
              });
 
            } else {
              answers.push({
                section_question_id: q.section_question_id,
                answer_text: value || ""
              });
            }
          });
        });
 
        form_data.append("answers", JSON.stringify(answers));
 
        const res = await axios.post(
          `${this.base_url}/report_incident_management/submit_form_answers/`,
          form_data,
          this.axios_config()
        );
 
        // Show success screen
        this.reference_number = res.data.application_id || "N/A";
        this.success_screen = true;
 
        // Reset form data
        this.select_default_entity_type();
        this.selected_form_id = null;
        this.form_schema = [];
        this.form_data = {};
        this.files = [];
 
        await this.fetch_pending_entities(); // refresh the list
 
      } catch (err) {
        console.error(err);
        this.set_error(err.response?.data?.error || "Submission failed.");
      } finally {
        this.is_submitting = false;
      }
    },
 
    async fetch_pending_entities() {
      if (this.loading ) return;
      this.loading = true;
      const config = { ...this.axios_config(), params: { project_id: this.project_id } };

      try {
        const { data } = await axios.get(
          `${this.base_url}/report_incident_management/get_pending_entities/`,
          config
        );
 
        const rawEntries = Reflect.get(data.data, 'list_pending_entities') || [];
 
        this.logged_entries = rawEntries.map(entry => {
          // 1. Flatten all questions into one searchable array using Optional Chaining
          const allQuestions = entry.forms?.[0]?.sections?.flatMap(s => s.questions) || [];
 
          // 2. Helper for targeted extraction
          const findAnswer = (keywords) => {
            const normalizedKeywords = (Array.isArray(keywords) ? keywords : [keywords])
              .map(keyword => keyword.toLowerCase());

            const question = allQuestions.find(q => {
              const text = q.question_text?.toLowerCase() || "";
              return normalizedKeywords.some(keyword => text.includes(keyword));
            });

            return question?.answers?.[0]?.answer;
          };

          // 3. Specifically handle the "file" question type
          const fileQuestion = allQuestions.find(q => q.question_type === "file");
          const files = fileQuestion?.answers?.map((a, i) => ({
            name: a.file_name || `Attachment ${i + 1}`,
            url: a.presigned_url || a.answer || '#'
          })) || [];
 
          return {
            ...entry,
            location: findAnswer(["location", "incident location", "incident site", "address"]),
            description: findAnswer("description"),
            total_likes: entry.total_likes ?? entry.like_count ?? 0,
            total_comments: entry.total_comments ?? entry.comment_count ?? entry.comments?.length ?? 0,
            comments: entry.comments || [],
            files
          };
        });

        await Promise.allSettled(
          this.logged_entries.map(entry => this.fetch_incident_interactions(entry))
        );
 
      } catch (err) {
        console.error("Failed to fetch pending entities:", err);
      }finally{
        this.loading = false;
      }
    },
 
    trigger_file_input() {
    const element = this.$refs.fileInput;
   
    if (Array.isArray(element)) {
      element[0].click();
    } else {
      element.click();
    }
  },
 
    reset_modal() {
      this.clear_incident_modal();
      this.select_default_entity_type(true);
    }
  }
};
